export default __webpack_public_path__ + "./assets/background-pure-mobile__c4862e063d7cb174dc09ffb5dfa7b3f0.jpg";